import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task-check",
  "use": "task-check-usage",
  "viewBox": "0 0 23.12 20",
  "content": "<symbol viewBox=\"0 0 23.12 20\" id=\"task-check\"><defs><style>#task-check .a{stroke:#666;stroke-miterlimit:10;stroke-width:2.11px}</style></defs><path d=\"M16.17 15.86l1.9 1.68 3.38-4.21L23 15l-4.23 5h-1.21l-2.68-2.64v-1.5zm.15-6.67l1.9 1.68 3.39-4.21 1.51 1.68-4.23 5h-1.17L15 10.7V9.19zm0-6.67l1.9 1.68L21.61 0l1.51 1.67-4.23 5h-1.17L15 4V2.52zM13.63 12.56L12 10.92l-.95-1.18a5.94 5.94 0 0 0 .53-2.42 5.79 5.79 0 0 0-5.79-5.79 6 6 0 0 0-2.12.39l4.44 4.43-3.28 3.28L.4 5.2A5.71 5.71 0 0 0 0 7.32a5.78 5.78 0 0 0 5.79 5.78 5.59 5.59 0 0 0 1.79-.28l1.13 1.38 1.65 1.64 3 3.37\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/task-check.svg
// module id = OOW2
// module chunks = 1